// Utilities for the new price-based gain model.
// Informative % displayed next to each price is computed vs prev_close
// (same reference as Webull's headline % change).

export function pctVsPrevClose(price, prevClose) {
  if (price == null || prevClose == null || prevClose <= 0) return null;
  return (price / prevClose - 1) * 100;
}

// Price-based composed gain. Falls back to legacy percent-based if prices missing.
export function composedGainFromPrices(entryPrice, exitPrice, closePrice) {
  if (entryPrice == null || entryPrice <= 0) return null;
  const ref = exitPrice != null ? exitPrice : closePrice;
  if (ref == null) return null;
  return (ref / entryPrice - 1) * 100;
}

// Iter 26 — Test gain from market open: (close − open) / open × 100.
export function composedGainFromOpen(openPrice, closePrice) {
  if (openPrice == null || openPrice <= 0 || closePrice == null) return null;
  return (closePrice / openPrice - 1) * 100;
}

// Dispatches by status: Real uses entry→exit/close; Test uses open→close when
// an open price is available, else falls back to entry→close (backward compat).
export function composedGainForStock(stock) {
  const isReal = (stock?.status || "test").toLowerCase() === "real";
  const openP = stock?.open_price ?? stock?.criteria?.open_price;
  const ep = stock?.entry_price, xp = stock?.exit_price, cp = stock?.close_price;
  if (!isReal && openP != null && openP > 0 && cp != null) {
    return (cp / openP - 1) * 100;
  }
  return composedGainFromPrices(ep, xp, cp);
}

// Format a % informatively (e.g. "+12.4%" or "—")
export function formatPctInfo(pct, digits = 2) {
  if (pct == null || Number.isNaN(pct)) return "—";
  const sign = pct >= 0 ? "+" : "";
  return `${sign}${pct.toFixed(digits)} %`;
}
